<template>
  <div class='pros-button-component'></div>
</template>

<script>
  import { Button } from '@printos/agnostic-button';

  export default {
    props: {
      id: {
        type: String,
      },
      iconName: {
        type: String,
      },
      iconPath: {
        type: String,
      },
      iconUrl: {
        type: String,
      },
      iconSize: {
        type: String,
      },
      iconConstraint: {
        type: String,
      },
      iconPosition: {
        type: String,
      },
      shape: {
        type: String,
      },
      density: {
        type: String,
      },
      label: {
        type: String,
      },
      className: {
        type: String,
      },
      theme: {
        type: String,
      },
      mode: {
        type: String,
      },
      display: {
        type: String,
      },
      scheme: {
        type: String,
      },
      width: {
      },
      height: {
      },
      icon: {
        type: Boolean,
        default: false,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      solid: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      id: function(newVal) {
        this._printos.button.$set({id: newVal});
      },
      iconName: function(newVal) {
        this._printos.button.$set({iconName: newVal});
      },
      iconPath: function(newVal) {
        this._printos.button.$set({iconPath: newVal});
      },
      iconUrl: function(newVal) {
        this._printos.button.$set({iconUrl: newVal});
      },
      iconSize: function(newVal) {
        this._printos.button.$set({iconSize: newVal});
      },
      iconConstraint: function(newVal) {
        this._printos.button.$set({iconConstraint: newVal});
      },
      iconPosition: function(newVal) {
        this._printos.button.$set({iconPosition: newVal});
      },
      icon: function(newVal) {
        this._printos.button.$set({icon: newVal});
      },
      shape: function(newVal) {
        this._printos.button.$set({shape: newVal});
      },
      density: function(newVal) {
        this._printos.button.$set({density: newVal});
      },
      label: function(newVal) {
        this._printos.button.$set({label: newVal});
      },
      className: function(newVal) {
        this._printos.button.$set({className: newVal});
      },
      theme: function(newVal) {
        this._printos.button.$set({theme: newVal});
      },
      mode: function(newVal) {
        this._printos.button.$set({mode: newVal});
      },
      scheme: function(newVal) {
        this._printos.button.$set({scheme: newVal});
      },
      display: function(newVal) {
        this._printos.button.$set({display: newVal});
      },
      disabled: function(newVal) {
        this._printos.button.$set({disabled: newVal});
      },
      solid: function(newVal) {
        this._printos.button.$set({solid: newVal});
      },
      width: function(newVal) {
        this._printos.button.$set({width: newVal});
      },
      height: function(newVal) {
        this._printos.button.$set({height: newVal});
      },
      loading: function(newVal) {
        this._printos.button.$set({loading: newVal});
      },
    },
    mounted() {
      this._printos = {};
      this._printos.button = new Button({
        target: this.$el,
        props: {
          id: this.id,
          iconName: this.iconName,
          iconPath: this.iconPath,
          iconUrl: this.iconUrl,
          iconSize: this.iconSize,
          iconConstraint: this.iconConstraint,
          iconPosition: this.iconPosition,
          icon: this.icon,
          shape: this.shape,
          density: this.density,
          label: this.label,
          className: this.className,
          myStyle: this.style,
          theme: this.theme,
          mode: this.mode,
          scheme: this.scheme,
          display: this.display,
          disabled: this.disabled,
          direction: this.direction,
          solid: this.solid,
          width: this.width,
          loading: this.loading,
        },
      });

      this._printos.button.$on('clicked', event => {
        // this.$emit('click', event.detail);

        this.$emit('clicked', event.detail);
      });
    },
    unmounted() {
      this._printos.button.$destroy();
    },
  }
</script>
